import script from "./ClusterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClusterView.vue?vue&type=script&setup=true&lang=ts"

import "./ClusterView.vue?vue&type=style&index=0&id=045e3054&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045e3054"]])

export default __exports__